export default __webpack_public_path__ + "static/media/028-summer shirt.134d7a50.svg";